import React from 'react'; // ★ React import
import { Outlet } from 'react-router-dom'; // ★ Link, useLocation は Header/Footer で使う

import { useDepartment } from '@/entities/department'; // ★ Department は Header/Footer で使うので削除'
import { useViewer } from '@/entities/user'; // ★ FSD パス
import { Footer } from '@/widgets/footer'; // ★ Footer ウィジェットをインポート
import { Header } from '@/widgets/header'; // ★ Header ウィジェットをインポート
// Sentryテストコンポーネントを削除

// AppLayout コンポーネントを定義
export const AppLayout: React.FC = () => {
  // useLocation は Header/Footer 内部へ移動
  const { isLoaded: isAuthLoaded } = useViewer(); // ★ useViewer を使用
  const {
    isLoading: isDeptLoading,
    selectedDeptId,
    userDepartments,
    selectDepartment,
    error: deptError,
  } = useDepartment();

  const isLoading = !isAuthLoaded || isDeptLoading;

  if (isLoading) {
    // ★ 共有ローディング表示 (@shared/ui/loader など) を使うのが望ましい
    return (
      <div className="loading-container-center">
        <p>読み込み中...</p>
      </div>
    );
  }

  if (deptError) {
    // ★ 共有のエラー表示コンポーネントを使用することを検討
    return <div className="error-message">エラー: {deptError}</div>;
  }

  if (!selectedDeptId && userDepartments.length === 0 && !isLoading) {
    console.log(
      'AppLayout: No department selected and user has no departments.'
    );
  }

  // isGenActive, isHistoryActive は Header/Footer 内部へ移動

  // ★ 型安全のため event の型を明示
  const handleDeptChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newDeptId = event.target.value;
    selectDepartment(newDeptId || null); // 空文字の場合 null を渡す
  };

  // Header と Footer に渡す props を整理
  const headerFooterProps = {
    userDepartments,
    selectedDeptId,
    isDeptLoading, // isDeptLoading は Header/Footer の disabled 判定に使う可能性あり
    onDeptChange: handleDeptChange, // Header に渡す
  };

  return (
    <div className="app-container">
      <Header {...headerFooterProps} />

      {/* メインコンテンツ */}
      <main className="app-main">
        {!selectedDeptId && userDepartments.length > 0 && !isLoading && (
          <div className="warning-message">
            ヘッダーからクリニックを選択してください。
          </div>
        )}
        {(selectedDeptId || (userDepartments.length === 0 && !isLoading)) && (
          <Outlet />
        )}
      </main>

      <Footer />
    </div>
  );
};
